import { useCallback } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';

/**
 * « Est-ce moi ? » pour un id d'utilisateur : comparé à l'URN de la session ($:teiji:user:12), seul endroit qui en
 * connaît le format
 */
export function useIsCurrentUser(): (userId: id | number) => boolean {
  const currentUrn = useAuthStore((state) => state.user?.urn);

  return useCallback((userId) => !!currentUrn?.endsWith(`:user:${userId}`), [currentUrn]);
}
